module.exports = __webpack_public_path__ + "static/media/img100_R.7c3d6f5d.jpg";